import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core'
import { TypographyComponent } from '../typography'
import { IconComponent } from '../icon'
import { IconTypes, IconValuesType } from '../icon/icon.component.types'
import { Router } from '@angular/router'

@Component({
  selector: 'hyperkit-message',
  standalone: true,
  imports: [CommonModule, IconComponent, TypographyComponent],
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageComponent {
  private router = inject(Router);

  @Input() public type: 'default' | 'success' | 'warning' | 'error' | 'info' =
    'default'
  @Input() public text = ''
  @Input() public closable = false
  @Input() public actionText?: string
  @Input() public actionCallback?: () => void

  public get getText(): string {
    if (this.text) return this.text
    if (this.type === 'error') {
      return 'HUNTER has encountered an error. Please try again or contact support.'
    }
    return ''
  }

  public get getActionText(): string | undefined {
    if (this.actionText) return this.actionText
    if (this.type === 'error') {
      return 'Get Support'
    }
    return undefined
  }

  public getIconClass(): IconValuesType {
    switch (this.type) {
      case 'success':
        return IconTypes.Check
      case 'warning':
        return IconTypes.AlertOctagon
      case 'error':
        return IconTypes.XOctagon
      case 'info':
        return IconTypes.Info
      default:
        return IconTypes.Info
    }
  }

  /** Returns the message type class for ngClass binding */
  get typeClass(): string {
    return this.type
  }

  /** Called when user clicks close */
  onClose(): void {
    //
  }

  onAction(): void {
    if (this.actionCallback) {
      this.actionCallback()
    } else if (this.type === 'error') {
      this.router.navigate(['/customer-support'])
    }
  }
}
